import styled from 'styled-components'
interface IBox {
  color: string
}
export const Container = styled.div``
export const Card = styled.div<IBox>`
  position: relative;
  background: ${props => props.theme.colors.colorf2f7ff};
  width: 100%;
  height: 40px;
  overflow: hidden;
  margin-top: 7px;

  display: flex;
  align-items: center;
  gap: 8px;

  padding: 0 17px 0 8px;

  border-radius: ${({ theme }) => theme.zds.border.radius100};
  border-left: 4px solid ${props => props.color || props.theme.zds.colors.neutral1000};
  transition: 0.2s;

  cursor: pointer;

  .icon {
    width: 25px;
    height: 25px;

    svg {
      fill: ${props => props.color || '#000'};
      width: 24px;
      height: 24px;
    }
  }

  .infos {
    position: relative;
    width: 100%;

    span {
      font-weight: bold;
      font-size: 14px;
      color: ${props => props.theme.colors.color6b7786};
    }
  }
`
